import { Dialog as MuiDialog, DialogProps } from "@mui/material"
import { useEffect } from "react"
import { APP_INTERACTION_TYPES } from "../shared/constants"
import { useAssessmentStore } from "../shared/store"

const Dialog = ({
    onClose,
    dialogId,
    ...props
}: DialogProps & {
    dialogId: string
    onClose: (
        event: Record<any, any>,
        reason: "backdropClick" | "escapeKeyDown" | "backpress"
    ) => void
}) => {
    const { addToPopupStack, removeLastPopup } = useAssessmentStore((state) => ({
        addToPopupStack: state.addToPopupStack,
        removeLastPopup: state.removeLastPopup,
    }))

    useEffect(() => {
        function onBackPress() {
            onClose?.({}, "backpress")
        }

        window.addEventListener(APP_INTERACTION_TYPES.BACK_PRESS, onBackPress)

        return () => {
            window.removeEventListener(APP_INTERACTION_TYPES.BACK_PRESS, onBackPress)
        }
    }, [onClose])

    useEffect(() => {
        if (props.open) {
            addToPopupStack(dialogId)
        } else {
            removeLastPopup()
        }
    }, [props.open, addToPopupStack, removeLastPopup, dialogId])

    return <MuiDialog {...props} />
}

export default Dialog
